export default "__VITE_ASSET__DMQW2D8h__"